import { ICalendar } from 'datebook';
import * as FileSaver from 'file-saver';

export const AddToMonthlyCalendar = (
  startDate: string,
  endDate: string,
  CalendarTitleMessage: string,
  CalendarDescriptionMessage: string,
  NoOfInstallments: number,
) => {
  const StartEvent = new Date(startDate);
  StartEvent.setHours(9);
  StartEvent.setMinutes(0);
  const EndEvent = new Date(startDate);
  EndEvent.setHours(9);
  EndEvent.setMinutes(30);
  const parseEntities = (text: any) =>
    new DOMParser().parseFromString(text, 'text/html').body.innerText;
  const config: any = {
    title: CalendarTitleMessage,
    description: parseEntities(CalendarDescriptionMessage),
    start: new Date(StartEvent), // Start date of the callback window
    end: new Date(EndEvent), // End date of the callback window
    recurrence: {
      frequency: 'MONTHLY',
      interval: 1,
      count: NoOfInstallments,
    },
  };

  const icalendar = new ICalendar(config);

  // fs.writeFileSync('my-event.ics', icalendar.render());

  //icalendar.download("test123");
  const ics = icalendar.render();
  const blob = new Blob([ics], {
    type: 'text/calendar',
  });

  FileSaver.saveAs(blob, 'my-monthly-calendar-event.ics');
};
